import MainReport from "./components/MainReport";

function index() {
  return <MainReport />;
}

export default index;
